<template>
  <div class="object-page-wrapper">
    <div class="page-content d-flex f-column">
      <div class="page-content__meta d-flex f-between">
        <h1 class="page-title">№{{ flat.number }}</h1>
        <div @click="$router.go(-1)" class="go-back-icon">
          <svg class="d-block ml-auto" xmlns="http://www.w3.org/2000/svg" width="17.999" height="18"
            viewBox="0 0 17.999 18">
            <path id="Union_9" data-name="Union 9"
              d="M-10501-7368.2l-7.2,7.2-1.8-1.8,7.2-7.2-7.2-7.2,1.8-1.8,7.2,7.2,7.2-7.2,1.8,1.8-7.2,7.2,7.2,7.2-1.8,1.8Z"
              transform="translate(10510 7379)" fill="#fefefc" />
          </svg>
        </div>
      </div>

      <div class="flat-wrap f-full">
        <div class="flex-container">
          <div class="flex-half p-relative">
            <div class="flat-meta-items">
              <span>Подъезд</span>
              <p>{{ flat.enterance_number }}</p>
            </div>
            <div class="flat-meta-items">
              <span>Статус</span>
              <p style="font-size: 16px">{{ flat.status }}</p>
            </div>
            <div class="flat-meta-items">
              <span>Этаж</span>
              <p>{{ flat.floor_number }}</p>
            </div>
            <div class="flat-meta-items">
              <span>Комнаты</span>
              <p>{{ flat.rooms }}</p>
            </div>
            <div class="flat-meta-items">
              <span>Площадь</span>
              <p>
                {{ flat.area }} м
                <sup>2</sup>
              </p>
            </div>
            <div class="flat-meta-items">
              <span>Высота потолков</span>
              <p>до {{ flat.height }} м</p>
            </div>

            <div v-if="flat.start_of_sale == 1" class="flat-meta-cost">
              <span>
                Цена за м
                <sup>2</sup>
              </span>
              <el-switch style="display: block; margin: 12px 0; line-height: unset;" v-model="price_type" active-color="#13ce66"
                inactive-color="#ff4949" active-text="Актуальная цена с ремонтом"
                inactive-text="Актуальная цена без ремонта">
              </el-switch>
              <p>
                {{ pricePerSquareMeter | formatNumber }} сум. / м
                <sup>2</sup>
              </p>
            </div>

            <div class="flat-descr">
              <div class="flat-new-cost" v-if="flat.start_of_sale == 1">
                <h1>{{ totalFlatPrice | formatNumber }} сум.</h1>
              </div>

              <button aria-haspopup="openPopup" type="submit" class="form-group__button text-white pointer mb-4">Оставьте
                заявку</button>
              <span class="d-block">
                Позвонить нам:
                <a href="tel:+998712333330" class="ml-1 text-white">+998 (71) 233 33 30</a>
              </span>
            </div>

            <div class="flat-form p-absolute w-100 h-100" aria-modal="formModal">
              <div class="flat-form__close pointer" aria-hidden="formModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="17.999" height="18" viewBox="0 0 17.999 18">
                  <path id="Union_9" data-name="Union 9"
                    d="M-10501-7368.2l-7.2,7.2-1.8-1.8,7.2-7.2-7.2-7.2,1.8-1.8,7.2,7.2,7.2-7.2,1.8,1.8-7.2,7.2,7.2,7.2-1.8,1.8Z"
                    transform="translate(10510 7379)" fill="#fefefc" />
                </svg>
              </div>
              <span class="flat-form__title">Оставьте заявку</span>
              <SendFlatRequest :flat_id="flat_id"></SendFlatRequest>
            </div>
          </div>

          <div class="flex-half">
            <div class="flat-img flat-img__full h-100 p-relative brightness" ref="reloadImage" :style="{
              background: `url(${imageUrl})`,
            }">
              <div class="img-loader p-absolute w-100 h-100 child-center" v-if="loader">
                <div class="img-loader__circle"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BottomNavigation />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BottomNavigation from "../../components/layout/BottomNavigation";
import SendFlatRequest from "./components/SendFlatRequest.vue";
import { preloadImages } from "@/utils";

export default {
  data() {
    return {
      flat: {},
      imageUrl: "",
      loader: true,
      flat_id: null,
      price_type: false
    };
  },

  components: {
    BottomNavigation,
    SendFlatRequest
  },

  computed: {
    ...mapGetters({
      flatInfo: "flats/flatInfo",
    }),

    pricePerSquareMeter: function () {
      return this.flat.type_home ? (this.price_type ? Math.round(parseFloat(this.flat.type_home.actual_price_with_repair)).toFixed(2) : Math.round(parseFloat(this.flat.type_home.actual_price_without_repair)).toFixed(2)) : 0;
    },

    totalFlatPrice: function () {
      return this.flat.area ? (parseFloat(this.flat.area) * this.pricePerSquareMeter) : 0;
    },
  },

  mounted() {
    this.flat_id = this.$route.params.id;
    if (!this.flat_id) {
      this.$router.go(-1);
    }

    this.fetchData();
    this.nom();
  },

  filters: {
    formatNumber(n, c, d, t) {
      var c = isNaN((c = Math.abs(c))) ? 0 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? " " : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
        j = (j = i.length) > 3 ? j % 3 : 0;

      return (
        s +
        (j ? i.substr(0, j) + t : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
        (c
          ? d +
          Math.abs(n - i)
            .toFixed(c)
            .slice(2)
          : "")
      );
    }
  },

  methods: {
    ...mapActions({
      getFlatInfo: "flats/getFlatInfo"
    }),

    fetchData() {
      if (this.flat_id) {
        const { reloadImage } = this.$refs;
        var preload = preloadImages(reloadImage);

        this.getFlatInfo(this.flat_id)
          .then((res) => {
            this.flat = res.flatInfo;
            this.imageUrl = res.image_path;

            preload.then(() => {
              this.loader = false;
            });
          })
          .catch((err) => {
          });
      }
    },

    nom() {
      const _button = document.querySelector('[aria-haspopup="openPopup"]'),
        _modal = document.querySelector('[aria-modal="formModal"]'),
        _close = document.querySelector('[aria-hidden="formModal"]');

      _button.addEventListener("click", function () {
        _modal.classList.add("flat-form__active");
      });

      _close.addEventListener("click", function () {
        _modal.classList.remove("flat-form__active");
      });
    },
  }
};
</script>

<style>
.brightness {
  filter: brightness(2);
}

#layout-canvas {
  user-select: none;
}
</style>
